import { Container } from "@brightagency/headstart-common";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import React, { FC } from "react";
import { useNotificationBar } from "../../../services/app-state";
import { useSuburbInformationNullable } from "../../../utils";
import { RichText } from "../../atoms/RichText";
import { Wrapper, Content, CloseButton, Outer } from "./styled";


export const NotificationBar: FC = () => {

    const pathname = window.location.pathname;
    let enabled : boolean | undefined = false;
    const data = useSuburbInformationNullable();

    // if(pathname === '/hdstrt/'){ // local
    if(pathname === '/'){ // live
        enabled = data?.notification_bar_enabled;
    } else {
        enabled = false;
    }

    const suburbnotificationcontent = useSuburbInformationNullable()?.notification_bar_content;
    // const enabled = useSuburbInformationNullable()?.notification_bar_enabled;
    // const [{ enabled, content, hasUserClosed }, { closeNotificationBar }] = useNotificationBar();
    const [{  hasUserClosed }, { closeNotificationBar }] = useNotificationBar();
    const notificationSessionStorage = sessionStorage.getItem('hasUserClosed');
    
    const isShowing = enabled && !hasUserClosed && !notificationSessionStorage;
    // const isShowing = suburbnotificationenaled && !hasUserClosed;

    if (!isShowing) {
        return null;
    }

    return (
        <Container>
            <Outer>
                <Wrapper>
                    <WarningRoundedIcon />
                    <Content>
                        <RichText content={suburbnotificationcontent} />
                    </Content>
                    <CloseButton onClick={closeNotificationBar}>
                        <CloseRoundedIcon fontSize="small" />
                    </CloseButton>
                </Wrapper>
            </Outer>
        </Container>
    );
};
